import * as R from 'ramda';

import { currentYear } from '@/helpers/date';
import { formatNumber } from '@/helpers/formatNumber';
import { calculateTodayReturns, calculateValue, calculateYesterdayValue, formatPrice } from '@/helpers/transactions';

import { Props } from './transactions-journal';

export const getTransactionsJournalStats = ({ transactions = [] }: Props) => {
  const transactionsCount = transactions.length;
  const totalCost = R.sum(R.pluck('acquisitionValue', transactions));
  const totalValue = R.sum(R.map(calculateValue, transactions));

  const todayReturns = R.sum(R.map(calculateTodayReturns, transactions));
  const yesterdayValue = R.sum(R.map(calculateYesterdayValue, transactions));
  const todayReturnsYield = (todayReturns / yesterdayValue) * 100;

  const totalReturns = formatNumber(totalValue - totalCost) as number;
  const totalReturnsYield = totalCost > 0 ? (totalReturns / totalCost) * 100 : 0;

  const avgReturnsPerTransaction = totalReturns / transactionsCount;
  // @ts-ignore
  const avgYieldPerTransaction = R.sum(R.pluck('returnYield', transactions)) / transactionsCount;

  return {
    transactionsCount,
    totalCost: formatPrice(formatNumber(totalCost, 0) as number),
    totalValue: formatPrice(formatNumber(totalValue, 0) as number),
    todayReturns: formatPrice(formatNumber(todayReturns, 0) as number),
    todayReturnsYield: `${formatNumber(todayReturnsYield)} %`,
    totalReturns: formatPrice(formatNumber(totalReturns, 0) as number),
    totalReturnsYield: `${formatNumber(totalReturnsYield)} %`,
    avgReturnsPerTransaction: formatPrice(formatNumber(avgReturnsPerTransaction, 0) as number),
    avgYieldPerTransaction: `${formatNumber(avgYieldPerTransaction)} %`,
  };
};

export const getCurrentYearStats = ({ transactions = [] }: Props) =>
  getTransactionsJournalStats({
    transactions: transactions.filter(({ sellDate }) => sellDate.startsWith(currentYear)),
  });
